import { render, staticRenderFns } from "./CotizadorFunerario.vue?vue&type=template&id=67e8e434&"
import script from "./CotizadorFunerario.vue?vue&type=script&lang=js&"
export * from "./CotizadorFunerario.vue?vue&type=script&lang=js&"
import style0 from "./CotizadorFunerario.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports